module.exports = __webpack_public_path__ + "static/img/back-9-2.143b29be.png";